@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="container">
  <div class="row">
    <div class="span9">
      <h1> Generate Metadata Report Message</h1>
    </div>
    <p class="lead">
      Generate an oadrReport message describing a Metadata Report. This does not send anything to external VTNs, just generates a sample payload.
    </p>
  </div>
  @if(isLoading) {
    <app-loader
      message="Loading...">
    </app-loader>
  } @else {
    <form name="requestForm" class="form-horizontal">
      <div class="form-group">
        <label for="reportSpecifierId"> Metadata Id (format: [id] : [report_specifier_id] : [label]): </label>
        <select id="reportSpecifierId" class="form-control" name="id" type="select"  (change)="setId($event.target)" required >
          <option disabled selected value=""></option>
          @for(metadata_reports of reports; track reports) {
            <option [value]="metadata_reports.id">{{metadata_reports.id}} : {{metadata_reports.report_specifier_id}}{{metadata_reports.label ? " : " : null}}{{metadata_reports.label}}</option>
          }
        </select>
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performAction()" [disabled]="!id">Perform action</button>
    </form>
    <h5> Request Results</h5>
    <blockquote class="blockquote" style="height: 500px">
      <textarea readonly [ngModel]="result" class="form-control" style="height: 100%"></textarea>
    </blockquote>
  }
</div>
